import styles from './style.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import drawing_png from "../../../assets/drawing.png";
import {  ClickAwayListener, Fade, Popover, Slide  } from 'newmaterial-ui';
import { useTranslation } from 'react-i18next';
 
import Button from '../../../design-system/lib/Button';
import { DRIVER_COLOR, HASHTAG, LOCATION, personGrey, PickupOnly_Deactive } from '../../../assets';
import Checkbox from '../../../design-system/lib/Checkbox';
import Typography from '../../../design-system/lib/Typography';
import Tag from '../../../design-system/lib/Tag';
import { isEmpty } from 'lodash';
import { Table_DeSelectOrder, Table_SelecteMultiOrders, Table_SelectOrder } from '../../../Redux/actions/actionNames';
 

export const MapClusterSelection = () => {
		const selectedCluster = useSelector((state) => state.Map.selectedCluster)
		const [list, setList] = useState(null);
	const RedyxselectedOrders = useSelector((state) => state.Table.selectedOrders)
		const [selected, setSelected] = useState({});
		const [selectedOrders, setSelectedOrders] = useState([]);

		const { t, i18n } = useTranslation();
		 const dispatch = useDispatch();
 
 
		 	 useEffect(() => {
				if(!list){
					 let selected = [];
				   let sse = {}
					let sse2 = {}

       		 selectedCluster?.forEach((itemx) => {
						 selected.push(itemx.properties)
						 sse[itemx.properties?.id] = itemx.properties
						 if (RedyxselectedOrders[itemx.properties?.id]) {
							 sse2[itemx.properties?.id] = itemx.properties
						 }

       		 })

					 setList(selected)
					 setSelectedOrders(sse)
					setSelected(sse2)
				}

				if(!selectedCluster){
					setList(null)
				}
				 
				 }, [list , selectedCluster] )




 

 
		 if(!selectedCluster && !list){
			return null
		 }

console.log("vsrgvfsdrgfvxx ", selected)

	return  <ClickAwayListener onClickAway={() => { 
			
			dispatch({type : "selectedCluster" , state :null})
			
			}}>
		<Slide direction="right"  in={selectedCluster}  timeout={200}><div className={styles.Container}>

				<div className={styles.header}>
						<Typography weight='Body_Middle_Bold' text={t("Select pins")} style={{color:"#242424",marginInlineStart :"16px"}}  />

						<Button size='Medium' type='Primary' isActive onClick={()=>{
					// dispatch(Table_SelecteMultiOrders(selected))
							dispatch({type : "selectedCluster" , state :null})
							}} text={t('Done')}  style={{marginInlineEnd :"16px"}} />
				</div>
					<div className={styles.status}>
						<Checkbox onClick={()=>{

						if (Object.keys(selected).length - (Object.keys(selectedOrders).length) == 0) {
							setSelected({})

							list?.forEach((item) => {
								dispatch(Table_DeSelectOrder(item.id))
							})

						} else {
							let ex = {}

							list?.forEach((item) => {
								ex[item.id] = item
							})
							setSelected(ex)
							dispatch(Table_SelecteMultiOrders(ex))

						}



						}} size='Small' state={Object.keys(selected).length - (Object.keys(selectedOrders).length) == 0 ? "checked" : "unchecked"}  style={{marginInlineStart :"16px"}} />
						<Typography weight='Body_Middle_Medium' text={`${Object.keys(selected).length}/${Object.keys(selectedOrders).length} ${t("selected")}`} style={{color:"#242424",marginInlineStart :"10px"}}  />
				</div>
						<div className={styles.list} style={{paddingBottom:"300px"}}>

							{list?.map((item)=>{
								return <div onClick={() => {
									if (RedyxselectedOrders[item.id]) {
										let newex = selected
										delete newex[item.id]
										console.log("vsrgvfsdrgfv ", selected, newex)

										setSelected({ ...newex })
										dispatch(Table_DeSelectOrder(item.id))

									} else {
										dispatch(Table_SelectOrder(item))
										setSelected({ ...selected, [item.id]: item })
									}
								}


								} style={{ height: "65px", width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "start", borderBottom: "1px solid #F4F4F7" }}>
						<div style={{ width:"100%" ,height: "45px" ,display:"flex",flexDirection:"column", justifyContent:"center",alignItems:"start" ,gap:"8px" }}>
						<div  style={{ display:"flex",flexDirection:"row", justifyContent:"center",alignItems:"start" ,gap:"10px",width :"100%" }}>
											<Checkbox size='Small' state={RedyxselectedOrders[item.id] ? 'checked' : "unchecked"} onClick={() => { }} style={{ marginInlineStart: "16px" }} /> <Typography weight="Body_Middle_Medium" text={item[item.category].address} style={{ color: "#242424", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1" }} />
						</div>
						<div style={{marginInlineStart :"38px" ,gap:"6px",width:"100%" ,display:"flex" , flexDirection:"row" , justifyContent:"start" ,alignItems:"center"}}>
							<Tag backgroundColor="GrayUltraLight" color="TextNormal" size="Medium" text={item.code} weight="Body_Small_Regular" icon={HASHTAG} iconSize="16"   />
							<Tag backgroundColor="GrayUltraLight" color="TextNormal" size="Medium" text={t(item.category)} weight="Body_Small_Regular" icon={PickupOnly_Deactive} iconSize="16"   />
							{!isEmpty(item[item.category].fullName) && <Tag backgroundColor="GrayUltraLight" color="TextNormal" size="Medium" text={item[item.category].fullName} weight="Body_Small_Regular" icon={personGrey} iconSize="16"   />}
						</div>
					</div>

				</div>
							})}

			

				</div>
 
		</div></Slide>
			</ClickAwayListener> 
  };





const OrderCheckbox = ({ checked, ...props }) => {

		// const ordersOpen = useSelector((state) => state.Monitoring.orders.open)
		// const dispatch = useDispatch();
		// const { t, i18n } = useTranslation();

		// function handleOpenCloseOrders() {
		//     dispatch(MonitoringHandleActiveOrders(!ordersOpen))
		// }


		// return (
		//     <div className={styles.popperItemFrame}>
		//         <span className={styles.popperItemText}> {t("Orders")}  </span>
		//         <input className={clsx(styles.checkboxWrapper, ordersOpen ? styles.checked : '')} type="checkbox"
		//             onClick={handleOpenCloseOrders}
		//             {...props}
		//         />
		//     </div>
		// );
		 const [anchorEl, setAnchorEl] =  useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	return (
		< >
			<Button onClick={handleClick} size='Small' type='Secondary' icon={LOCATION} className={styles.btng}  style={{backgroundColor: open && "#80808033"}} text={<>Order Stops | <span style={{color:"#242424" , fontWeight:"500"}}>All </span></>}  />
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
						 style={{ marginTop: "-4px" ,
								boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)', // تغییر باکس شادو
							}} // فاصله 16 پیکسل از بالای دکمه
							sx={{}}
				anchorOrigin={{
						vertical: 'top',
						horizontal: 'center',
				}}
				transformOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
				}}
				classes={{ paper: styles.Popover }}
			>
				<div className={styles.popoverContainer}>
					<span className={styles.cheConta}> <Checkbox size='Small' state='checked'  /> <Typography weight='Body_Small_Regular' style={{color:"#484848"}} text={"Pickups"} /> </span>
					<span className={styles.cheConta}> <Checkbox size='Small' state='checked'  /> <Typography weight='Body_Small_Regular' style={{color:"#484848"}} text={"Dropoffs"} /> </span>
					<span className={styles.cheConta2}>  <Typography weight='Body_Tiny_Bold' style={{color:"#242424"}} text={"Reset"} /> <Typography weight='Body_Tiny_Bold' style={{color:"#1080FF"}} text={"Apply"} /></span>

				</div>
			</Popover>
		</ >
	);
};


const DriverCheckbox = ({ checked, ...props }) => {
		const driversOpen = useSelector((state) => state.Monitoring.drivers.open)
		const dispatch = useDispatch();
		const { t, i18n } = useTranslation();


		// function handleOpenCloseDrivers() {
		//     dispatch(MonitoringHandleActiveDrivers(!driversOpen))
		// }

		// return (
		//     <div className={styles.popperItemFrame} style={{ marginBottom: "0" }}>
		//         <span className={styles.popperItemText}> {t("Drivers")} </span>
		//         <input className={clsx(styles.checkboxWrapper, driversOpen ? styles.checked : '')} type="checkbox"
		//             onClick={handleOpenCloseDrivers}
		//             {...props}
		//         />
		//     </div>
		// );


				 const [anchorEl, setAnchorEl] =  useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	return (
		< >
			<Button onClick={handleClick} size='Small' type='Secondary' icon={DRIVER_COLOR} className={styles.btng} style={{backgroundColor: open && "#80808033"}} text={<>Drivers | <span style={{color:"#242424" , fontWeight:"500"}}>All </span></>}  />
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
						 style={{ marginTop: "-4px" ,
								boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)', // تغییر باکس شادو
							}} // فاصله 16 پیکسل از بالای دکمه
				anchorOrigin={{
						vertical: 'top',
						horizontal: 'center',
				}}
				transformOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
				}}
				classes={{ paper: styles.Popover }}
			>
				<div className={styles.popoverContainer}>
					<span className={styles.cheConta}> <Checkbox size='Small' state='checked'  /> <Typography weight='Body_Small_Regular' style={{color:"#484848"}} text={"Free"} /> </span>
					<span className={styles.cheConta}> <Checkbox size='Small' state='checked'  /> <Typography weight='Body_Small_Regular' style={{color:"#484848"}} text={"Busy"} /> </span>
					<span className={styles.cheConta2}>  <Typography weight='Body_Tiny_Bold' style={{color:"#242424"}} text={"Reset"} /> <Typography weight='Body_Tiny_Bold' style={{color:"#1080FF"}} text={"Apply"} /></span>

				</div>
			</Popover>
		</ >
	);
};



const MapSelection = ({ checked, ...props }) => {
	 const DrawingRef = useSelector((state) => state.Map.drawingRef)
	 const drawingRefMode = useSelector((state) => state.Map.drawingRefMode)

		const dispatch = useDispatch();
		const { t, i18n } = useTranslation();
		const [isGoogle, setIsGoogle] = useState(global.config.dispatcherSettings.applicationMap.type );
		const [indexx, setIndexx] = useState(0);

	 const handleRectangle = useCallback(( ) => {

		if(isGoogle == "google" && DrawingRef){
							dispatch({type : "drawingRefMode" , state:"rectangle"})

				 DrawingRef.current?.state.drawingManager?.setDrawingMode(null);
				 DrawingRef.current?.state.drawingManager?.setDrawingMode("rectangle");
				 setIndexx(2)
		 }
 
		}, [isGoogle , DrawingRef , indexx]);

	 const handlePolygon = useCallback(( ) => {

		if(isGoogle == "google" && DrawingRef){
				dispatch({type : "drawingRefMode" , state:"polygon"})

				 DrawingRef.current?.state.drawingManager?.setDrawingMode(null);
				 DrawingRef.current?.state.drawingManager?.setDrawingMode("polygon");
				 setIndexx(1)
		 }
 
		}, [isGoogle , DrawingRef , indexx]);


	 const handleHand = useCallback(( ) => {

		if(isGoogle == "google" && DrawingRef){
										dispatch({type : "drawingRefMode" , state:null})

				 DrawingRef.current?.state.drawingManager?.setDrawingMode(null);
				 setIndexx(0)
		 }
 
		}, [isGoogle , DrawingRef , indexx]);


 

		 
			 useEffect(() => {
			 !drawingRefMode && setIndexx(0)
				}, [drawingRefMode] )
		
		 

	return (
			<div className={styles.MonitoringToolBar}>
				<div className={styles[`selectedImg_${indexx}`]} />
				<div style={{position:"relative", width:'16px',height:"16px",overflow:"hidden",position:"relative"}} onClick={handleHand}>
								 <img src={drawing_png} style={{
									position: 'absolute',
									left: '0px',
									top: '-144px',
									userSelect: 'none',
									border: '0px',
									padding: '0px',
									margin: '0px',
									maxWidth: 'none',
									width: '16px',
									height: '192px'
							}} />
				</div>
			 <div style={{position:"relative", width:'16px',height:"16px",overflow:"hidden",position:"relative"}} onClick={handlePolygon}>
								 <img src={drawing_png} style={{
									position: 'absolute',
									left: '0px',
									top: '-64px',
									userSelect: 'none',
									border: '0px',
									padding: '0px',
									margin: '0px',
									maxWidth: 'none',
									width: '16px',
									height: '192px'
							}} />
				</div>
							<div style={{position:"relative", width:'16px',height:"16px",overflow:"hidden",position:"relative"}} onClick={handleRectangle}>
								 <img src={drawing_png} style={{
									position: 'absolute',
									left: '0px',
									top: '-16px',
									userSelect: 'none',
									border: '0px',
									padding: '0px',
									margin: '0px',
									maxWidth: 'none',
									width: '16px',
									height: '192px'
							}} />
				</div>
		 </div>
	 );
};